import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PanelMap from './Map';
import Header from '../Header/Header';
import styles from './SavedMapView.module.css';
import { useError } from '../Contexts/ErrorContext';
import { useLoading } from '../Contexts/LoadingContext';
import LoadingIndicator from '../../LoadingIndicator';
import dateFunctions from '../../../utils/dateFunctions.js';
import QueryStringService from '../../../services/queryStringService.js';

const SavedMapView = () => {
    const { mapId } = useParams();
    const [mapData, setMapData] = useState(null);
    const [error, setError] = useState(null);
    const { showError } = useError();
    const { setIsLoading, isLoading } = useLoading();
    const queryStringService = useMemo(() => new QueryStringService(), []);
    const countryCode = useMemo(() => queryStringService.getCurrentCountry(), [queryStringService]);
    const [savedAt, setSavedAt] = useState("");

    useEffect(() => {
        if (mapData) {
            const formattedDate = dateFunctions.getCountrySpecificDateTimeFormatFromDate(
                countryCode,
                mapData.savedAt)
                ?? new Date(mapData.savedAt).toLocaleString()
                ?? "";
            setSavedAt(formattedDate);
        }
    }, [countryCode, mapData])

    useEffect(() => {
        const fetchMapData = async () => {
            if (!mapId) {
                setError('Invalid map ID');
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                const response = await fetch(`/api/maps/${mapId}`);

                if (!response.ok) {
                    throw new Error(`Failed to load map: ${response.statusText}`);
                }

                const data = await response.json();
                setMapData(data.panel_locations);
            } catch (err) {
                //console.error('Error fetching map data:', err);
                setError(err.message || 'Failed to load the saved map');
                showError('Could not load the saved map. It may have been deleted or the URL is incorrect.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchMapData();
    }, [mapId, showError, setIsLoading]);

    if (error) {    
        return (
            <div className={styles.errorContainer}>
                <h2>Map Not Found</h2>
                <p>{error || 'The requested map could not be loaded'}</p>
                <button
                    className={styles.backButton}
                    onClick={() => window.history.back()}
                >
                    Go Back
                </button>
            </div>
        );
    }

    return (

        <div>
            <div>
                <LoadingIndicator
                    loading={isLoading}
                />
            </div>
            {!isLoading && mapData &&
                <div className={styles.savedMapContainer}>
                    <Header
                        showExportButton={false}
                        customerName={mapData?.customerName}
                        showHeaderDRButton={false}
                        showOverviewButton={false}
                        showOverviewButton={false}
                        showLabel={true}
                        label={"Map - " + mapData?.campaignName}
                        showSubLabel={true}
                        subLabel={"Saved on: " + savedAt}
                    />

                    <div className={styles.mapWrapper}>
                        <PanelMap
                            campaignType={mapData.campaignType || 'posting'}
                            orderId={null}
                            customerId={null}
                            panels={mapData.panels || []}
                            initialCenter={mapData.center}
                            initialZoom={mapData.zoom}
                            isLoadedMap={false}
                            mapId={mapId}
                        />
                    </div>
                </div>
            }
        </div>

    );
};

export default SavedMapView;